import { cn } from '@/lib/utils';
import type { LucideIcon } from 'lucide-react';

interface SenderHeroProps {
	children: string;
	icon?: LucideIcon;
	className?: string;
}

export default function SenderHero({ children, icon: Icon, className }: SenderHeroProps) {
	return (
		<div className={cn('flex items-start gap-3', className)}>
			{Icon ? (
				<div className='flex size-10 shrink-0 items-center justify-center rounded-xl bg-primary/10 text-primary'>
					<Icon size={20} />
				</div>
			) : null}
			<p className='text-[20px] font-medium leading-snug'>{children}</p>
		</div>
	);
}
